export default "/_next/static/a06a0797bb797db409dd833c6f63a328.png";